import { render } from "./gang-change-status.vue?vue&type=template&id=1670f962"
import script from "./gang-change-status.vue?vue&type=script&lang=js"
export * from "./gang-change-status.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__